import React, { useCallback, useEffect } from 'react';

import { toast } from 'react-toastify';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { useStepHook } from '../logic/useStepHook';
import { StepView } from './StepView';
import { useVerifyEmailCodeMutation } from '../logic/useVerifyEmailCodeMutation';
import { useVerifySsnCardMutation, VerifySsnCardReturn } from '../logic/useVerifySsnCardMutation';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { WizardFlowActionType } from '../logic/WizardContext';
import { ApiError } from '../ChangePhone';
import { useCountdownTimer } from '../../../hooks/utilities/useCountdownTimer';

export const MailStep = () => {
  const { data, dispatch, t, customerId, handleErrorCode, email } = useStepHook();
  const { apiResponseData, lastFourCard, lastFourSSN } = data;
  const { startTimer, timeLeft } = useCountdownTimer({ intervalDuration: 30, onFinishCountdown: () => {} });

  useEffect(() => {
    startTimer();
  }, []);

  const onError = useCallback((error: ApiError) => {
    handleErrorCode(error);
  }, []);
  const handleSuccessVerify = useCallback((apiData: any) => {
    dispatch({ type: WizardFlowActionType.NEXT_STEP });
    dispatch({ type: WizardFlowActionType.SET_DATA, payload: { apiResponseData: apiData } });
  }, []);
  const successfulResend = (apiData: VerifySsnCardReturn) => {
    dispatch({
      type: WizardFlowActionType.SET_DATA,
      payload: { apiResponseData: apiData.newPhoneNumberResponseCustomData.stateToken },
    });

    toast(
      <LiliNotification
        type={LiliNotificationType.SUCCESS}
        title='Sent Email'
        text={`Successfully sent email to ${email}`}
        id='change-phone-email-notification'
      />,
      {
        ...LiliToastDefaultConfig,
        autoClose: false,
        position: toast.POSITION.BOTTOM_CENTER,
        closeOnClick: false,
        closeButton: false,
      },
    );
  };
  const { isLoading, mutate: mutateVerify } = useVerifyEmailCodeMutation(handleSuccessVerify, onError);
  const { mutate: mutatereSendMail } = useVerifySsnCardMutation(successfulResend, onError);

  const handleMail = useCallback(
    (value: string) => {
      dispatch({ type: WizardFlowActionType.SET_DATA, payload: { mailAnswer: value } });
      if (data?.apiResponseData) {
        mutateVerify({ answer: value, newPhoneNumberResponseCustomData: data.apiResponseData, customerId });
      }
    },
    [dispatch, apiResponseData],
  );
  const handleResendMail = useCallback(() => {
    if (lastFourCard && lastFourSSN) mutatereSendMail({ email, cardLastFourDigits: lastFourCard, ssn: lastFourSSN });
    startTimer();
  }, [dispatch, data]);
  const subHeader = t('CHANGE_PHONE.MAIL.SUB_HEADER', {
    email,
  });
  return (
    <StepView
      title={t('CHANGE_PHONE.MAIL.TITLE')}
      headLineSmallText={subHeader}
      buttonTitle={t('CHANGE_PHONE.BUTTON_TITLE')}
      handleResendMail={handleResendMail}
      handleClick={handleMail}
      numOfDigits={6}
      isLoading={isLoading}
      countdown={timeLeft || 0}
    />
  );
};
